import React from 'react';
import emptyLanguageProvider from '@codeblock/languages/lib/empty';
import emptyThemeProvider from '@codeblock/themes/lib/empty';
import { Codeblock } from './Codeblock';
export var emptyProviders = {
  themes: emptyThemeProvider,
  languages: emptyLanguageProvider
};
export var CodeblockEmpty = function CodeblockEmpty(props) {
  return React.createElement(Codeblock, Object.assign({
    providers: emptyProviders
  }, props));
};
export default CodeblockEmpty;